import { render, staticRenderFns } from "./agentSetting.vue?vue&type=template&id=235e7062&scoped=true&"
import script from "./agentSetting.vue?vue&type=script&lang=ts&"
export * from "./agentSetting.vue?vue&type=script&lang=ts&"
import style0 from "./agentSetting.vue?vue&type=style&index=0&id=235e7062&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235e7062",
  null
  
)

export default component.exports